import { render } from "./categories-modal.vue?vue&type=template&id=b76b3714"
import script from "./categories-modal.vue?vue&type=script&lang=js"
export * from "./categories-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__